import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { NgIf } from '@angular/common';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-bary-icon-button',
  templateUrl: './bary-icon-button.component.html',
  standalone: true,
  imports: [NgIf, MDBBootstrapModulesPro, BaryIconComponent],
})
export class BaryIconButtonComponent {
  @Input() icon!: string;
  @Input() size = '';
  @Input() color = 'primary';
  @Input() floating = true;
  @Input() outline = false;
  @Input() class?: string;
  @Input() tooltip?: string;

  @Output() clickEvent = new EventEmitter<any>();

  protected readonly FAS = FaDirectiveEnum.FAS;

  handleClick(event?: MouseEvent): void {
    this.clickEvent.emit(event);
  }
}
